import React from 'react'
import ChargebackTemplate from '../ChargebacksTemplate/ChargebackTemplate'

const Assessment = () => {
  return (
    <div>
      <ChargebackTemplate title='Assessment' status="Assessment"/>
    </div>
  )
}

export default Assessment
